import React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

function CustomError() {
    const partnerPhone = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : "1-888-439-7443"
    );

    return (
        <div className="l-page-container">
            <div className="box col-xs box-custom-error" style={{ height: "auto", width: "auto" }}>
                <div className="box-content">
                    <div className="box-description flex-center justify-center">The system is currently unavailable. Please try again later. If you continue to experience an issue, please contact us at {" "}
                        {partnerPhone}.</div>
                    <br />
                    <div className="box-description flex-center justify-center">
                        We apologize for any inconvenience.
                    </div>
                </div>
            </div>                      
        </div>
    );
}

export default CustomError;
